import React from 'react';

import './styles.css';

const GREEN = 'green';
const RED = 'red';
const BLUE = 'blue';
const ORANGE = 'orange';
const LIGHT_ORANGE = 'lightOrange';
const GREEN_BLUE = 'greenBlue';
const GREY = 'grey';
const LIGHT_GREY = 'lightGrey';
const DARK_DUSTY_PINK = 'darkDustyPink';

const DEFAULT_COLOR = BLUE;

const STATUS_COLOR = {
  [GREEN]: '#49cd35',
  [RED]: '#ff4242',
  [BLUE]: '#5d7ea3',
  [ORANGE]: '#ff9420',
  [LIGHT_ORANGE]: '#ffbd5e',
  [GREEN_BLUE]: '#00c6c0',
  [GREY]: '#8091a5',
  [LIGHT_GREY]: '#b5beca',
  [DARK_DUSTY_PINK]: '#d277a4'
};

const StatusBox = ({status, color}: any) => {
  let backgroundColor: any = undefined;

  /*
   * We can pass either a hex - starting with `#`: <StatusBox color="#ffffff" status="Status" />
   * Or we can pass one of the specific color variables defined above: <StatusBox color={StatusBox.GREEN} status="Status" />
   * If we can't determine the color, a default is used: <StatusBox status="Status" />
   */

  if (color && color.startsWith('#')) {
    backgroundColor = color;
  } else {
    backgroundColor = STATUS_COLOR[color] || STATUS_COLOR[DEFAULT_COLOR];
  }

  return (
    <div className="StatusBox" style={{backgroundColor: backgroundColor}}>
      <p className="status">{status}</p>
    </div>
  );
};

StatusBox.GREEN = GREEN;
StatusBox.RED = RED;
StatusBox.BLUE = BLUE;
StatusBox.ORANGE = ORANGE;
StatusBox.LIGHT_ORANGE = LIGHT_ORANGE;
StatusBox.GREEN_BLUE = GREEN_BLUE;
StatusBox.GREY = GREY;
StatusBox.LIGHT_GREY = LIGHT_GREY;
StatusBox.DARK_DUSTY_PINK = DARK_DUSTY_PINK;

export default StatusBox;
